import { render, staticRenderFns } from "./imageDataTable.vue?vue&type=template&id=18e579eb&lang=pug"
import script from "./imageDataTable.vue?vue&type=script&lang=js"
export * from "./imageDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports